<div class="wells-summary-tab-container">
  <!-- Multi-well: Well cards -->
  <ng-container *ngIf="isMultiWellMode">
    <div class="multi-well-section">
      <h3 class="section-title">Selected Wells</h3>
      <div class="well-cards">
        <div *ngFor="let w of multiWellCards" class="well-card">
          <div class="well-field">
            <p class="field-label">Well Name</p>
            <p class="field-value">{{ w.name }}</p>
          </div>
          <div class="well-field">
            <p class="field-label">Field</p>
            <p class="field-value">{{ w.field }}</p>
          </div>
          <div class="well-field">
            <p class="field-label">Area</p>
            <p class="field-value">{{ w.area }}</p>
          </div>
          <div class="well-field">
            <p class="field-label">Abandonment Start</p>
            <p class="field-value">{{ w.abandonmentStart }}</p>
          </div>
          <div class="well-field">
            <p class="field-label">Abandonment End</p>
            <p class="field-value">{{ w.abandonmentEnd }}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Single-well: Identification + Background -->
  <ng-container *ngIf="!isMultiWellMode">
    <div class="single-well-section">
      <!-- Well Identification -->
      <div class="info-card">
        <div class="card-header">
          <h3 class="card-title">Well Identification</h3>
        </div>
        <div class="card-content">
          <div *ngFor="let row of wellsIdentification" class="info-row">
            <p class="info-label">{{ row.label }}</p>
            <p class="info-value">{{ row.value }}</p>
          </div>
        </div>
      </div>

      <!-- Well Background -->
      <div class="info-card">
        <div class="card-header">
          <h3 class="card-title">Well Background</h3>
        </div>
        <div class="card-content">
          <div *ngFor="let row of wellsBackgroundFields" class="info-row">
            <p class="info-label">{{ row.label }}</p>
            <p class="info-value">{{ row.value }}</p>
          </div>
          <div *ngFor="let block of wellsBackgroundLists" class="info-list-block">
            <p class="list-title">{{ block.title }}</p>
            <ul>
              <li *ngFor="let item of block.items">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
